import { useEffect, useState } from 'react';
import { parse } from 'yaml';

// CRAではimport.meta.globが使えないため、ファイル名を明示的にリスト化
const LESSON_FILES = [
    'pronunciation_lesson.yaml',
    'pronunciation_exam.yaml'
];
export function useLessonFlow() {
    const [lessons, setLessons] = useState([]);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        let mounted = true;
        const load = async () => {
            setLoading(true);
            const loaded = [];
            const errors = [];
            await Promise.all(LESSON_FILES.map(async (filename) => {
                const path = `${process.env.PUBLIC_URL}/lessons/${filename}`;
                try {
                    const response = await fetch(path);
                    if (!response.ok) {
                        errors.push(`レッスンファイルの読み込みに失敗しました: ${filename}`);
                        return;
                    }
                    const content = await response.text();
                    const parsed = parse(content);
                    if (!parsed || typeof parsed !== 'object') {
                        errors.push(`レッスン定義の読み込みに失敗しました: ${path}`);
                        return;
                    }
                    if (!parsed.metadata || typeof parsed.metadata !== 'object') {
                        errors.push(`metadata が存在しません: ${path}`);
                        return;
                    }
                    if (!parsed.metadata.id) {
                        errors.push(`metadata.id が存在しません: ${path}`);
                        return;
                    }
                    if (!parsed.states || typeof parsed.states !== 'object') {
                        errors.push(`states が存在しません: ${path}`);
                        return;
                    }
                    const states = {};
                    for (const [stateId, stateDef] of Object.entries(parsed.states)) {
                        if (!stateDef || typeof stateDef !== 'object') {
                            errors.push(`状態 ${stateId} の定義が不正です: ${path}`);
                            continue;
                        }
                        const buttons = Array.isArray(stateDef.buttons)
                            ? stateDef.buttons.filter(button => button && typeof button === 'object' && button.label)
                            : [];
                        const autoPlay = Array.isArray(stateDef.autoPlay)
                            ? stateDef.autoPlay.filter(action => action && typeof action === 'object' && action.type)
                            : [];
                        states[stateId] = {
                            overlay: stateDef.overlay,
                            buttons,
                            autoPlay,
                            live2d: stateDef.live2d
                        };
                    }
                    const initialState = parsed.initialState ||
                        parsed.metadata.initialState ||
                        Object.keys(states)[0];
                    if (!initialState) {
                        errors.push(`初期状態が特定できません: ${path}`);
                        return;
                    }
                    loaded.push({
                        metadata: {
                            ...parsed.metadata,
                            initialState
                        },
                        states,
                        initialState
                    });
                }
                catch (err) {
                    console.error(`レッスン定義のパースに失敗しました: ${path}`, err);
                    errors.push(`レッスン定義のパースに失敗しました: ${path}`);
                }
            }));
            if (!mounted)
                return;
            loaded.sort((a, b) => a.metadata.title?.localeCompare(b.metadata.title ?? '', 'ja') ?? 0);
            setLessons(loaded);
            setError(errors.join('\n'));
            setLoading(false);
        };
        load();
        return () => {
            mounted = false;
        };
    }, []);
    return { lessons, error, loading };
}
